/* wishlist.js — localStorage-backed, no account/app required */

const WISHLIST_KEY = "aaliyans_wishlist";

function getWishlist() {
  try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
  catch { return []; }
}

function setWishlist(list) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  document.dispatchEvent(new CustomEvent("wishlist:updated", { detail: { list } }));
}

function isWishlisted(handle) {
  return getWishlist().includes(handle);
}

function toggleWishlist(handle) {
  let list = getWishlist();
  if (list.includes(handle)) {
    list = list.filter(h => h !== handle);
  } else {
    list.push(handle);
  }
  setWishlist(list);
  return list.includes(handle);
}

function syncButtons() {
  document.querySelectorAll("[data-wishlist-toggle]").forEach(btn => {
    const handle = btn.dataset.productHandle;
    const active = isWishlisted(handle);
    btn.classList.toggle("active", active);
    btn.setAttribute("aria-pressed", active ? "true" : "false");
  });
}

document.addEventListener("DOMContentLoaded", () => {
  syncButtons();

  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-wishlist-toggle]");
    if (!btn) return;
    e.preventDefault();
    const active = toggleWishlist(btn.dataset.productHandle);
    btn.classList.toggle("active", active);
    btn.setAttribute("aria-pressed", active ? "true" : "false");
  });

  // Wishlist listing page: render saved products by fetching each handle
  const listingRoot = document.querySelector("[data-wishlist-page]");
  if (listingRoot) renderWishlistPage(listingRoot);
});

async function renderWishlistPage(root) {
  const handles = getWishlist();
  if (!handles.length) {
    root.innerHTML = `<p class="empty-state">Your wishlist is empty. Tap the heart on any product to save it here.</p>`;
    return;
  }

  root.innerHTML = `<div class="product-grid" data-wishlist-grid></div>`;
  const grid = root.querySelector("[data-wishlist-grid]");

  const products = await Promise.all(
    handles.map(h => fetch(`/products/${h}.js`).then(r => r.ok ? r.json() : null).catch(() => null))
  );

  grid.innerHTML = products.filter(Boolean).map(p => `
    <article class="card" data-product-handle="${p.handle}">
      <div class="card-media">
        <button class="wishlist-btn active" data-wishlist-toggle data-product-handle="${p.handle}" aria-pressed="true">
          <svg viewBox="0 0 24 24" width="18" height="18"><path d="M12 20.5s-7.5-4.6-10-9.3C.4 8 1.6 4.5 5 3.4c2.2-.7 4.4.2 5.5 2 .3.5.7 1.1 1.5 1.1s1.2-.6 1.5-1.1c1.1-1.8 3.3-2.7 5.5-2 3.4 1.1 4.6 4.6 3 7.8-2.5 4.7-10 9.3-10 9.3Z"/></svg>
        </button>
        <a href="/products/${p.handle}"><img src="${p.featured_image}" width="500" height="650" alt="${p.title}" loading="lazy"></a>
      </div>
      <div class="card-body">
        <a href="/products/${p.handle}" class="card-title">${p.title}</a>
        <div class="card-price"><span class="new">${(p.price / 100).toLocaleString(undefined, { style: "currency", currency: window.Shopify?.currency?.active || "PKR" })}</span></div>
      </div>
    </article>
  `).join("");

  document.dispatchEvent(new CustomEvent("wishlist:rendered"));
}
